import { CourseType, LessonType } from '../../../types'
import { getCourseLessons } from './getCourseLessons'

// Returns the total running time (in seconds) of all the 
// videos within the lessons of the course

export const getCourseVideoLength = (course: CourseType) => {
  const allLessons = getCourseLessons(course)

  const totalVideoLength = allLessons.reduce((videoLength: number, lesson: LessonType) => {
    return videoLength + (lesson.video?.duration || 0)
  }, 0)

  return totalVideoLength
}
